"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCEPTED = 'accepted';
exports.ACCESS_REQUESTED = 'accessRequested';
exports.ACTIONED = 'actioned';
exports.CHECKED_IN = 'checkedIn';
exports.COMMENTED = 'commented';
exports.CREATED = 'created';
exports.DELETED = 'deleted';
exports.FILE_ADDED = 'fileAdded';
exports.FILE_REMOVED = 'fileRemoved';
exports.GRANTED = 'granted';
exports.HEARTED = 'hearted';
exports.MEMO_CREATED = 'memoCreated';
exports.MEMO_SHARED = 'memoShared';
exports.PENDING = 'pending';
exports.REJECTED = 'rejected';
exports.SHARED = 'shared';
exports.UNSHARED = 'unshared';
exports.UPDATED = 'updated';
exports.VIEWED = 'viewed';
//# sourceMappingURL=strings.js.map